import { takeLatest, put, call, select } from 'redux-saga/effects';
import { CHECK_EMAIL_CODE_SAGA } from "../sagaTypes";
import { loadingAction } from '../actions.js';
import { url } from "../../config";
import { toast } from 'react-hot-toast';
import { checkEmailFormAction, authAction, registrationAction } from "../actions";
import { CHECK_EMAIL_FORM_INITIAL, REGISTRATION_FORM_INITIAL } from "../initialStateConstants";

const request = data => {
    return fetch(`${ url }/check_email_code`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerCheckEmailCode(args) {
    const auth_form = yield select(state => state.auth_form);
    const est = yield select(state => state.est);

    yield put(loadingAction(true));
    try {
        let formData = new FormData();
        formData.append('code', args.data?.code);
        formData.append('email', args.data?.email);

        if (est.slug && est.id) {
            formData.append('slug', est.slug);
            formData.append('est', est.id);
        }

        const response = yield call (request, formData);

        if (response.success) {
            // Закрываем форму проверки кода из письма
            yield put(checkEmailFormAction(CHECK_EMAIL_FORM_INITIAL));
            // Закрываем форму регистрации и очищаем данные
            yield put(registrationAction(REGISTRATION_FORM_INITIAL));
            // Открываем авторизации
            yield put(authAction({
                ...auth_form,
                open: true
            }));

            toast.success(response.message);
        }
        else if (response.error) {
            toast.error(response.message);
        }
    }
    catch(error) {
        console.log(error);
        yield put(loadingAction(false));
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherCheckEmailCode() {
    yield takeLatest(CHECK_EMAIL_CODE_SAGA, workerCheckEmailCode);
}